import { EPlacingType } from '../../types';

export function mergePlacingType(
  prevPlacingType: EPlacingType,
  nextPlacingType: EPlacingType,
  nextPackageIds: string[],
  nextPeriodIds: string[],
): EPlacingType {
  if (prevPlacingType === EPlacingType.package && nextPackageIds.length) {
    return EPlacingType.package;
  }

  if (prevPlacingType === EPlacingType.balance && nextPeriodIds.length) {
    return EPlacingType.balance;
  }

  return nextPlacingType;
}
